// @ts-nocheck
// LIBRARY
import React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Row, Col, Table, Button, Input, Icon, Drawer } from 'antd';
import TablePager from 'shared_components/table_pager';
import { fetchExamList } from 'services/blood_bank/exam_list';
import UserAccountForm from '../form';

const { Search } = Input;
const columns = [
	{
		title: 'EXAM NAME',
		dataIndex: 'exam_item_name',
		key: 'exam_item_name',
	},
	{
		title: 'EXAM DESCRIPTION',
		dataIndex: 'exam_item_desc',
		key: 'exam_item_desc',
	},
	{
		title: 'EVALUATION TYPE',
		dataIndex: 'evaluation_type',
		key: 'evaluation_type',
	},
];

class ExamListTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			examList: [],
			actionType: 'add',
			drawerTitle: '',
			loading: false,
			drawerButton: '',
			selectExam: {},
			pagination: {
				pageSize: 0,
			},
			pagination1: 0,
		};
	}

	onClose = () => {
		this.setState({
			visible: false,
			patientInfo: [],
		});
	};

	showDrawer = record => {
		this.setState({
			visible: true,
			drawerTitle: 'ADD EXAM LIST',
			drawerButton: 'ADD',
			actionType: 'add',
			selectExam: record,
		});
	};

	displayDrawerUpdate = record => {
		this.setState({
			visible: true,
			drawerTitle: 'UPDATE EXAM LIST',
			drawerButton: 'UPDATE',
			actionType: 'update',
			selectExam: record,
		});
	};

	async componentDidMount() {
		const examList = await fetchExamList();
		this.setState({
			examList: examList,
			usersRef: examList.results,
		});
		console.log(examList, 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
	}

	onSearch = value => {
		const searchedVal = value.toLowerCase();
		const { usersRef } = this.state;
		const filtered = usersRef.filter(item => {
			// eslint-disable-next-line camelcase
			const { exam_item_name } = item;

			return this.containsString(exam_item_name, searchedVal);
		});
		this.setState({ examList: filtered });
	};

	onChangeSearch = event => {
		const { usersRef } = this.state;
		if (event.target.value === '') this.setState({ examList: usersRef });
	};

	// Private Function
	containsString = (searchFrom, searchedVal) => {
		if (searchFrom === null || searchFrom === '') return false;
		return searchFrom
			.toString()
			.toLowerCase()
			.includes(searchedVal);
	};

	handleSelectChange = value => {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const pagination1 = { ...this.state.pagination };
		// eslint-disable-next-line radix
		pagination1.pageSize = parseInt(value);
		this.setState({ pagination1: pagination1 });
	};

	render() {
		const {
			drawerButton,
			patientInfo,
			visible,
			drawerTitle,
			selectExam,
			actionType,
			examList,
		} = this.state;
		return (
			<div>
				<div className="settings-user-table-action">
					<Row>
						<Col span={12}>
							<Search
								allowClear
								onSearch={value => this.onSearch(value)}
								onChange={this.onChangeSearch}
								style={{ width: 200 }}
								className="panel-table-search-input"
							/>
						</Col>
						<Col span={12} style={{ textAlign: 'right' }}>
							<Button
								type="primary"
								shape="round"
								style={{ marginRight: '15px' }}
								onClick={this.showDrawer}
							>
								<Icon type="plus" /> ADD EXAM
							</Button>
							<TablePager handleChange={this.handleSelectChange} />
						</Col>
					</Row>
				</div>
				<DndProvider backend={HTML5Backend}>
					<div className="settings-user-table">
						<Table
							dataSource={examList}
							columns={columns}
							rowKey={record => record.userID}
							onRow={record => {
								return {
									onDoubleClick: () => {
										this.displayDrawerUpdate(record);
									},
								};
							}}
						/>
					</div>
					{/* DRAWER */}
					<Drawer
						title={drawerTitle}
						width="30%"
						visible={visible}
						onClose={this.onClose}
						destroyOnClose
					>
						<UserAccountForm
							selectExam={selectExam}
							actionType={actionType}
							drawerButton={drawerButton}
							patientInfo={patientInfo}
							onClose={this.onClose}
						/>
					</Drawer>
				</DndProvider>
			</div>
		);
	}
}

export default ExamListTable;
